<div class="top-bar">
  <div class="bar-content">
    <mat-form-field class="pick-field">
      <b>Office</b>
      <mat-select
        [ngModel]="accountSelected?.id"
        (ngModelChange)="onAccountSelected($event)"
        >
        @for (account of accounts; track account) {
          <mat-option [value]="account.id">
            {{ account.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="pick-field">
      <b>Operation Type</b>
      <mat-select
        [ngModel]="operationTypeSelected?.id"
        (ngModelChange)="onOperationTypeSelected($event)"
        >
        @for (operationType of operationTypes; track operationType) {
          <mat-option
            [value]="operationType.id"
            >
            {{ operationType.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="pick-field">
      <b>Created from</b>
      <input
        [matDatepicker]="datepicker1"
        [ngModel]="dateFrom"
        (ngModelChange)="onDateFromChange($event)"
        matInput
        />
        <mat-datepicker-toggle
          [for]="datepicker1"
          matSuffix
        ></mat-datepicker-toggle>
        <mat-datepicker #datepicker1> </mat-datepicker>
      </mat-form-field>
      <mat-form-field class="pick-field">
        <b>Created to</b>
        <input
          [matDatepicker]="datepicker2"
          [ngModel]="dateTo"
          (ngModelChange)="onDateToChange($event)"
          matInput
          />
          <mat-datepicker-toggle
            [for]="datepicker2"
            matSuffix
          ></mat-datepicker-toggle>
          <mat-datepicker #datepicker2> </mat-datepicker>
        </mat-form-field>
        <button [ngClass]="{'buttonGoDisabled': !isFilterDisabled, 'gobutton': isFilterDisabled}" (click)="onGoButton()" mat-button>
          <mat-icon>refresh</mat-icon>
          Go
        </button>
        <button [ngClass]="{'export-button-disable': !isFilterDisabled, 'export-button': isFilterDisabled}"
          *ngIf="isManager"
          (click)="onExportButton()"
          mat-button>
          Export
          <mat-icon>download</mat-icon>
       </button>
      </div>
    </div>

    <div class="content-class">
      <mat-tab-group (selectedTabChange)="onTabSelected($event)">
        <mat-tab label="Inspections">
          @if (dataLoaded) {
            <div class="chart-class">
              @if (showChart) {
                <p-chart
                  #chart
                  [data]="data"
                  [options]="options"
                  type="line"
                  width="60vw"
                  height="60vh"
                ></p-chart>
              }
            </div>
          } @else {
            <mat-spinner class="center-loading" diameter="32"></mat-spinner>
          }
        </mat-tab>
        <mat-tab label="Inspectors">
          @if (dataLoaded) {
            <div class="chart-class">
              @if (showChart) {
                <p-chart
                  #chart
                  [data]="data"
                  [options]="options"
                  type="line"
                  width="60vw"
                  height="60vh"
                ></p-chart>
              }
            </div>
          } @else {
            <mat-spinner class="center-loading" diameter="32"></mat-spinner>
          }
        </mat-tab>
      </mat-tab-group>
    </div>

